import { blue } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { TextField } from 'shared/react-admin/Fields';

export const StyledTextField = styled(TextField)({
  cursor: 'pointer',
  color: blue[700],
  textDecoration: 'underline',
});
